module.exports = __webpack_public_path__ + "img/daftar-cargo.5c69f651.svg";